// extracted by mini-css-extract-plugin
export default {"wrapper":"mobile_wrapper__I4EpS"};